export default "__VITE_ASSET__Bkzpv3GF__"